import { formatUkTime } from './ukDate';

/**
 * A slot's instant as the UK time of day it is, "HH:mm" (Europe/London). It used to add the browser's
 * CURRENT offset, so in October BST a slot after the clocks went back read an hour late.
 *
 * @param {string} str  an ISO instant
 * @returns {string}
 */
export default function formatIsoString(str){
    return formatUkTime(str);
}
